import { BowelMovementReportResponse } from "../../services/api/types/forms/responses/BowelMovementReportResponse";
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BowelMovementHistoryResponse } from "../../services/api/types/forms/responses/BowelMovementHistoryResponse";
import { RootState } from "../../services/store";

type ResidentId = number;

interface State {
  bowelMovements: Record<ResidentId, BowelMovementReportResponse[]>;
}

const initialState: State = {
  bowelMovements: {},
};

export const bowelMovementsSlice = createSlice({
  name: "bowelMovements",
  initialState,
  reducers: {
    storeBowelMovements: (
      state,
      action: PayloadAction<BowelMovementHistoryResponse>,
    ) => {
      const { data } = action.payload;
      data.forEach((entry) => {
        const residentId = entry.resident.id;
        if (!state.bowelMovements[residentId]) {
          state.bowelMovements[residentId] = [];
        }

        // Check if the entry already exists
        const exists = state.bowelMovements[residentId].some(
          (existingEntry) => existingEntry.id === entry.id,
        );
        if (!exists) {
          state.bowelMovements[residentId].push(entry);
        }
      });
    },
  },
});

export const { storeBowelMovements } = bowelMovementsSlice.actions;

export const selectResidentBowelMovementLogs = createSelector(
  [
    (state: RootState) => state.bowelMovements?.bowelMovements,
    (_: RootState, residentId?: number) => residentId,
  ],
  (bowelMovements, residentId) =>
    !residentId ? [] : bowelMovements?.[residentId] || [],
);

export default bowelMovementsSlice.reducer;
